import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router'

// FPCC
import { makePlural } from 'common/utils/urlHelpers'
import ActionsMenu from 'components/ActionsMenu'
import AudioButton from 'components/AudioButton'

function DictionaryGridTilePresentation({ entry, wholeDomain }) {
  const title = entry?.title || ''
  // The string iterator that is used here iterates over characters,
  // not mere code units
  return (
    <div
      className="h-full w-full bg-white mx-auto flex items-center py-2 relative border-b-2 border-charcoal-100"
      data-testid="DictionaryGridTilePresentation"
    >
      <section
        id="EntryDetails"
        className="w-full flex items-center text-charcoal-900"
      >
        <div className="w-full">
          {wholeDomain && (
            <div className="p-1 inline-flex items-center justify-center text-xs font-medium rounded-md bg-blumine-100 capitalize text-blumine-color-700">
              {entry?.siteTitle}
            </div>
          )}

          {/* Title */}
          <div className="flex justify-between items-center w-full font-medium text-charcoal-900 text-xl">
            <Link
              key={entry.id}
              to={`/${entry?.sitename}/${makePlural(entry.type)}/${entry.id}`}
            >
              {title}
            </Link>

            <ActionsMenu.Presentation entry={entry} />
          </div>

          {/* Translations/Definitions */}
          {entry?.translations?.length > 0 && (
            <ol
              className={`${
                entry?.translations?.length === 1 ? 'list-none' : 'list-decimal'
              } list-inside my-2 text-charcoal-500`}
            >
              {entry?.translations?.map((translation) => (
                <li key={translation?.id} className="p-0.5">
                  {translation?.text}
                </li>
              ))}
            </ol>
          )}
          <div className="flex w-full">
            {/* Entry Audio */}
            <AudioButton audioArray={entry?.audio} />
          </div>
        </div>
      </section>
    </div>
  )
}
// PROPTYPES
const { bool, object } = PropTypes
DictionaryGridTilePresentation.propTypes = {
  entry: object,
  wholeDomain: bool,
}

export default DictionaryGridTilePresentation
